import React, { Component } from "react";
import {Map, InfoWindow, Marker, GoogleApiWrapper, MarkerWithLabel } from 'google-maps-react';
import { connect } from "react-redux";

import IconButton from 'material-ui/IconButton';

import Load from './Load'
import Card from './card'
import ExCard from './CardExpand'
import DriverCard from './driverCard'

import downArrow from './icon/downArrow.svg';
import upArrow from './icon/upArrow.svg';
import close from './icon/close.svg';
import close2 from './icon/close2.svg';
import mylo from './icon/man.png';
import bus from './icon/bus2.png';
import busstop from './icon/mymarker.png';
import info from './icon/info.svg';
import makr from './icon/marker.png';
import makr_yellow from './icon/marker_yellow.png';
import makr_green from './icon/marker_green.png';

import { Polygon } from "google-maps-react/dist/components/Polygon";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

var styleCard = {}
var styleExpand = {}
var styleDriver = {}
var nextStop2=''

class MapContainer extends Component  {

  constructor (props, context) {
    super(props, context)
    this.state = {
      showingCard: 'hidden',
      exshowingCard: 'hidden',
      DrivershowingCard: 'hidden',
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      value: "",
      nextStop: "",
      prevStop: "",
      showStation: false,
      latLonStation: [],
      arrPolyline: [],
      nearest:'',
      showAllMarker:'visible',
      showAllPoly:'visible',
    }
    
    // binding this to event-handler functions
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.expandClick = this.expandClick.bind(this);
    this.closeClick = this.closeClick.bind(this);
    this.reClick = this.reClick.bind(this);
    this.infoClick = this.infoClick.bind(this);
    this.closeinfoClick = this.closeinfoClick.bind(this);
    this.renderMarker = this.renderMarker.bind(this);
    this.renderStationMarker = this.renderStationMarker.bind(this);
    this.renderPolyline = this.renderPolyline.bind(this);
    this.renderAllPolyline = this.renderAllPolyline.bind(this);
    this.renderAllStation = this.renderAllStation.bind(this);
  }


  componentDidMount() {

    console.log(this.props,'-----------------')
    const { dispatch, transit, lati, long } = this.props
    const { isFetching, next  } = transit
    const location = [lati, long]

    this.loadData(); 
    this.intervalId = setInterval(() => this.loadData(), 5000);
    
    if(isFetching === true){
      return new Promise((resolve, reject ) => {
        dispatch({ 
          type: 'FETCH_TRANSIT',
          resolve,
          reject,
          next,
          location
        });
      })
    }
  }
  
  loadData() {

    const { dispatch, transit, lati, long } = this.props

    const { isFetching, next  } = transit
    const location = [lati, long]
   
      return new Promise((resolve, reject) => {
        dispatch({ 
          type: 'FETCH_TRANSIT',
          resolve,
          reject,
          next,
          location
        });
      })
  }


  onMarkerClick(props, marker, e){
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });
  }


  async handleClick(key){
    this.setState({
      showingInfoWindow: false,      
      showingCard: 'visible',
      exshowingCard: 'hidden',
      showStation: true,
      value: key,
      arrPolyline: '',
      showAllMarker: 'hidden',
      showAllPoly: 'hidden',
    });

    this.setState({"prevStop" : key.result.previous_stop.stop_id })

    nextStop2 = key.result.bus.next_stop.stop_id
    
    var polyLat = ''
    var polyLon = ''
    var poly = ''
    poly = key.result.polyline.substring (11,key.result.polyline.length-1)
    var poly2 = poly.split(",");
    var poly3 = ''
    var arrpoly =[]
    for(var i=0;i<poly2.length;i++){
      poly3 = poly2[i].split(" ")  
      for(var j=0;j<poly3.length;j++){
        if(j===0)
          polyLon = poly3[j]
        else if(j===1)
          polyLat = poly3[j]
      }
      arrpoly.push({lat:parseFloat(polyLat) , lng:parseFloat(polyLon)})

    }
    await this.setState({"arrPolyline": arrpoly})
    


    var arr_latlon = []
    for(var i=0;i<key.result.stop_list.length;i++){
      if(key.result.stop_list[i].nearest_to_user){
        await this.setState({"nearest": i})
      }
      arr_latlon.push({'lat': key.result.stop_list[i].latitude, 'lon': key.result.stop_list[i].longitude
                        , 'name': key.result.stop_list[i].stop_name, 'stop_id': key.result.stop_list[i].stop_id})
    }
    await this.setState({"latLonStation": arr_latlon})

    for(var i=0;i<key.result.stop_list.length;i++){
      if(key.result.stop_list[i].passed === false){
        this.setState({"nextStop" :  key.result.stop_list[i].stop_id}) 
        break;
      }
    }

    return arr_latlon

  }

  expandClick(){
    console.log('--------0--------')
    this.setState({
      exshowingCard: 'visible',
      showingCard: 'hidden',
      DrivershowingCard: 'hidden'
    });
  }

  reClick(){
    this.setState({
      showingCard: 'visible',
      exshowingCard: 'hidden',
    });
  }

  closeClick(){
    this.setState({
      showingCard: 'hidden',
      exshowingCard: 'hidden',
      DrivershowingCard: 'hidden',
      latLonStation: '',
      arrPolyline: '',
      showingInfoWindow: false,
      showAllMarker: 'visible',
      showAllPoly: 'visible',
    });
  }

  refreshClick(){
    alert('refresh')
  }

  infoClick(){
    this.setState({
      showingCard: 'visible',
      exshowingCard: 'hidden',
      DrivershowingCard: 'visible'
    });
  }

  closeinfoClick(){
    this.setState({
      DrivershowingCard: 'hidden',
      
    });
  }

  renderMarker(key){
    return(
      <Marker  
        key={`key-marker5-${key[0]}`}
        // title={'510'}
        onClick={this.handleClick.bind(this)}
        // name={item[0].bus_line}
        // route={item[0].direction_name}
        position={{ lat:key[1].bus.latitude, lng: key[1].bus.longitude}}
        icon={{url: bus}} 
        result={key[1]}
        label={key[1].bus.license_id}
      />
    )
  }

  renderAllPolyline(key){
    if(this.state.showAllPoly === 'visible'){
      var arr_test = []
      for(var i=key[1].length;i>=0;i--){
        if(key[1][i]){
          arr_test.push({lat: parseFloat(key[1][i].lat) , lng: parseFloat(key[1][i].lng)})
        }
      }
      for(var j=0;j<key[1].length;j++){
        if(key[1][j]){
          arr_test.push({lat: parseFloat(key[1][j].lat) , lng: parseFloat(key[1][j].lng)})
        }
      }
      return (
        <Polygon
        key = {key[0]}  
        paths={arr_test}
          strokeColor="#5c6bc0"
          strokeOpacity={0.8}
          strokeWeight={4}
          // fillColor="#fffff"
          fillOpacity={0} 
          // loop='false'
          />
      )
    }

  }

  renderAllStation(key){
    if(key[1]){
        if(this.state.showAllMarker === 'visible')
        return(
          <Marker 
            key={`key-station-${key[0]}`}
            // title={'510'}
            onClick={this.onMarkerClick}
            name={key[1].stop_name}
            // route={item[0].direction_name}
            position={{ lat:key[1].latitude, lng: key[1].longitude}}
            icon={{url: makr}} 
            // result={key[1]}
          />
        )
    }
  }


  renderStationMarker(key){

    if(parseInt(key[0]) === parseInt(this.state.nearest))
    { 
      return(
        <Marker 
          key={`key-marker-${key[0]}`}
          title={'station!'}
          onClick={this.onMarkerClick}
          name={key[1].name} 
          position={{ lat:parseFloat(key[1].lat), lng:parseFloat(key[1].lon)}}
          icon={{url: busstop}} 
          style={{ position:'absolute',zIndex:'100'}}
          result={key[1]}
        />
      )  

    }
    
    else if(parseInt(key[1].stop_id) === parseInt(this.state.nextStop)){
      return(   
        <Marker 
        key={`key-marker-${key[0]}`}
        title={'station!'}
        onClick={this.onMarkerClick}
          name={key[1].name} 
        position={{ lat:parseFloat(key[1].lat), lng:parseFloat(key[1].lon)}}
        result={key[1]}
        icon={{url: makr_yellow}} 
        style={{ position:'absolute',zIndex:'100'}}
        />
      )  
    }

    else if(key[1].stop_id === this.state.prevStop){
      return(   
        <Marker 
        key={`key-marker-${key[0]}`}
        title={'station!'}
        onClick={this.onMarkerClick}
          name={key[1].name} 
        position={{ lat:parseFloat(key[1].lat), lng:parseFloat(key[1].lon)}}
        result={key[1]}
        icon={{url: makr_green}} 
        style={{ position:'absolute',zIndex:'100'}}
        />
      )  
    }

    else{
        return(   
          <Marker 
          key={`key-marker-${key[0]}`}
          title={'station!'}
          onClick={this.onMarkerClick}
            name={key[1].name} 
          position={{ lat:parseFloat(key[1].lat), lng:parseFloat(key[1].lon)}}
          result={key[1]}
          icon={{url: makr}} 
          style={{ position:'absolute',zIndex:'100'}}
          />
        )  
    } 
  }

  renderPolyline(){
    if(this.state.arrPolyline.length===0){
      // console.log('this.state.arrPolyline')
    }
    else{
      var arr_test = []
      for(var i=this.state.arrPolyline.length;i>=0;i--){
        if(this.state.arrPolyline[i]){
          var alat = this.state.arrPolyline[i].lat
          var alon = this.state.arrPolyline[i].lng
        
          arr_test.push({lat: parseFloat(alat) , lng: parseFloat(alon)})
        }
      }
      for(var j=0;j<this.state.arrPolyline.length;j++){
        if(this.state.arrPolyline[j]){
          var alat = this.state.arrPolyline[j].lat
          var alon = this.state.arrPolyline[j].lng
        
          arr_test.push({lat: parseFloat(alat) , lng: parseFloat(alon)})
        }
      }
      return (
        <Polygon
          paths={arr_test}
          strokeColor="#3949ab"
          strokeOpacity={0.8}
          strokeWeight={4}
          // fillColor="#fffff"
          fillOpacity={0} 
          />
      )
    }
  }
  render() {
    var expandIcon,expandClose
    if (window.innerWidth < 800)  {
      styleCard = {
          position:'absolute',
          zIndex:'100', 
          width:'100%', 
          bottom:'0',
          marginBottom:'20px', 
          visibility:this.state.showingCard
      }
      
      styleExpand={
        position:'absolute',
        zIndex:'101', 
        width:'100%', 
        bottom:'0', 
        marginBottom:'20px', 
        visibility:this.state.exshowingCard
      }

      styleDriver={
        position:'absolute',
        zIndex:'101',
        width:'100%',
        visibility:this.state.DrivershowingCard 
      }

      expandIcon=upArrow
      expandClose=downArrow
    }
    else{
      styleCard = {
        position:'absolute',
        zIndex:'100', 
        width:'30%', 
        padding:'10px',
        visibility:this.state.showingCard
      }

      styleExpand={
        position:'absolute',
        zIndex:'101', 
        width:'30%', 
        padding:'10px',
        visibility:this.state.exshowingCard
      }

      styleDriver={
        position:'absolute',
        zIndex:'101',
        width:'30%',
        padding:'10px',
        paddingTop:'250px',
        visibility:this.state.DrivershowingCard 
      }

      expandIcon=downArrow
      expandClose=upArrow
    }




    // console.log('--------------------vi--------------------')
    const {lati, long, transit} = this.props
    // console.log(lati, long, '==========latlng')`
    const { results } = transit
    let item = {}
    if ( results ){
      item = results         
      var arr = [] 
      for(var i = 0; i<Object.keys(item).length; i++){
        var out = item[Object.keys(item)[i]].outbound
        var inbound = item[Object.keys(item)[i]].inbound
        if(out){
          arr.push(item[Object.keys(item)[i]].outbound)
        }
        if(inbound ){
          arr.push(item[Object.keys(item)[i]].inbound)
        }
      }      
    }
    
    var arrAllPoly =[]


    var poly = ''
    var poly3 = ''

    var poly2 = []
    for(var l=0;l<arr.length;l++){
      poly = (arr[l].polyline.substring(11,arr[l].polyline.length-1)).split(",")
      // console.log({poly})
      // poly3 = poly.split(" ")
      arrAllPoly = []
      for(var j=0;j<poly.length;j++){
        poly3 = poly[j].split(" ")
        arrAllPoly.push({lat:parseFloat(poly3[1]) , lng:parseFloat(poly3[0])})
      }

      poly2.push(arrAllPoly)
  
    }



    var arrStop =[]
    for(var j=0;j<arr.length;j++){
      for(var k=0;k<=arr[j].stop_list.length;k++){
        if(arr[j].stop_list[k]){
          arrStop.push(arr[j].stop_list[k])
        }
      }
    }

    // console.log(arrStop, '===========================arrarrarrarrarrarrarrarrarr')

    const speedtransit = transit.results
    if(speedtransit[0]){
      console.log(speedtransit[0].speed, '========transit=====')
    }

    if(lati){
      return ( 
        
        <div align='center' height='100%' >



            <div style={styleDriver}>  

              <IconButton style={{ position:'absolute',zIndex:'2', right:'0'}} >
                <img height="15px" width="15px" src={close2} onClick={this.closeinfoClick} alt=""/>
              </IconButton>

              <DriverCard />       
            </div> 


            <div style={styleCard}>  

              <IconButton style={{ position:'absolute',zIndex:'2', right:'0'}} >
                <img height="15px" width="15px" src={close} onClick={this.closeClick} alt=""/>
              </IconButton>

              <IconButton style={{ position:'absolute',zIndex:'2', left:'0', marginLeft:'30px'}} >
                <img height="25px" width="25px" src={info} onClick={this.infoClick} alt=""/>
              </IconButton>
  
              <IconButton style={{ position:'absolute',zIndex:'2', left:'0'}} >
                <img height="20px" width="20px" src={expandIcon} onClick={this.expandClick} alt=""/>
              </IconButton>

              <Card value={this.state.value} {...this.props} />       
            </div>


            <div style={styleExpand}>  
            
              <IconButton style={{ position:'absolute',zIndex:'2', right:'0'}} >
                <img height="15px" width="15px" src={close} onClick={this.closeClick} alt=""/>
              </IconButton>

              <IconButton style={{ position:'absolute',zIndex:'2', left:'0'}} >
                <img height="20px" width="20px" src={expandClose} onClick={this.reClick} alt=""/>
              </IconButton>


              <ExCard value={this.state.value}/> 
            </div>


          <Map google={this.props.google} zoom={14} mapTypeId={"roadmap"} initialCenter={{ lat: lati, lng: long }}
              style={{height:"83%", position:'absolute',top:'0' }}
              streetViewControl={true}
              zoomControl={true}
              fullscreenControl={true}
              mapTypeControl={false}
              >


              {Object.entries(poly2).map(this.renderAllPolyline)}

              {this.renderPolyline()}

            <Marker 
              title={'Click Me!'}
              onClick={this.onMarkerClick}
              name={'คุณอยู่ที่นี่'} 
              position={{ lat: lati, lng: long }}
              icon={{url: mylo}}
              style={{ position:'absolute',zIndex:'8'}}
            />

            {Object.entries(arrStop).map(this.renderAllStation)}

            {Object.entries(arr).map(this.renderMarker)}
            {Object.entries(this.state.latLonStation).map(this.renderStationMarker)}

            <InfoWindow
              onClose={this.windowHasClosed}
              marker={this.state.activeMarker}
              visible={this.state.showingInfoWindow}
            >
              <div>
                <h2 >{this.state.selectedPlace.name}</h2>
              </div>
            </InfoWindow>

          </Map>

        </div>
      );
    }
    else{
      return ( 
        <MuiThemeProvider >
          <Load />
        </MuiThemeProvider >
        
        
      )
    }
  }
}

const Container = connect()(MapContainer)

export default GoogleApiWrapper({apiKey: ('AIzaSyBp-4hXNhDUM_4n8FX4kUul6axwGbO0YR0')})(Container)


// WEBPACK FOOTER //
// ./src/Map.js